import React from 'react';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const StyledButtonLink = styled.button`
  background: none;
  border: 0;
  color: ${colors.N200};
  cursor: pointer;
  font-family: ${fontFamily};
  font-size: 14px;
  margin: 0;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: ${colors['near-black']};
  }

  &:active {
    color: ${colors.black};
  }

  &[disabled] {
    color: ${colors.N80};
    cursor: default;
    text-decoration: none;
  }
`;

const ButtonLinkContainer = styled.span`
  & + &::before {
    content: ' • ';
  }
`;

export const ButtonLink = (props) => (
  <ButtonLinkContainer>
    <StyledButtonLink {...props} />
  </ButtonLinkContainer>
);



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ButtonLink.js